import Inherit from '../../core/inherit';
import ResetPasswordDelegate from './reset-password.delegate';
import ValidationController from '../../core/validation.controller';
/**
 * @extends ValidationController
 * @extends ResetPasswordDelegate
 */
class ResetPasswordController extends Inherit(ValidationController, ResetPasswordDelegate) {
    async initialize() {
        // Check if user has valid data (not just an empty object)
        if (this.user && this.user.access && this.user.access.length > 0) {
            this.navigateDashboard();
            return;
        }

        await this.tokenInitialize();
    }

    get token() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('token');
    }

    async cleanup() {
        // Cleanup if needed
    }

    /**
     * Override tokenInitialize to use password reset validation instead of invitation validation
     */
    async tokenInitialize() {    
        const {token} = this;    
        if (token) {
            await this.validatePasswordResetToken(token);
        } else {
            this.navigateLogin();
        }
    }

    /**
     * Validate a password reset token
     * @param {string} token - The token to validate
     * @returns {Promise<void>}
     */
    async validatePasswordResetToken(token) {
        try {
            this.setState({ invitationValidating: true });
            const response = await this.data.validatePasswordReset(token);
            
            if (response && response.valid) {
                console.log(response);
                this.setState({ 
                    invitationValid: true, 
                    invitationData: response.user || { email: response.email },
                    email: response.email,
                    invitationValidating: false 
                });
            } else {
                this.setState({ 
                    invitationValid: false, 
                    invitationValidating: false 
                });
            }
        } catch (error) {
            console.error('Error validating password reset token:', error);
            this.setState({ 
                invitationValid: false, 
                invitationValidating: false 
            });
        }
    }

    async resetPassword() {
        const { password, confirmPassword, invitationData } = this.state;
        const {token} = this;
        
        // Basic validation
        if (!password || !confirmPassword) {
            this.setState({ error: true });
            console.log('Password or confirm password is empty');
            return;
        }

        if (password !== confirmPassword) {
            this.setState({ error: true });
            console.log('Passwords do not match');
            return;
        }

        if (password.length < 8) {
            this.setState({ error: true });
            console.log('Password is less than 8 characters');
            return;
        }

        // Check if we have invitation data with email
        if (!invitationData || !invitationData.email) {
            this.setState({ error: true });
            console.log('No invitation data or email');
            return;
        }

        if (!token) {
            this.setState({ error: true });
            console.log('No token');
            return;
        }

        try {
            this.setState({ loading: true, error: false });
            
            // Call the update password API with email and password
            const response = await this.data.updatePassword({ 
                email: invitationData.email,
                password: password,
                token: token
            });
            
            if (response?.success) {
                // Password updated successfully, clear the token from URL
                const url = new URL(window.location);
                url.searchParams.delete('token');
                window.history.replaceState({}, '', url);
                
                // Transition to success screen
                this.setState({ loading: false, showSuccessScreen: true });
                
                // Dispatch custom event to notify Login component
                window.dispatchEvent(new CustomEvent('passwordResetComplete'));
            } else {
                this.setState({ error: true });
            }
        } catch (error) {
            console.error('Error updating password:', error);
            this.setState({ error: true });
        } finally {
            this.setState({ loading: false });
        }
    }

    navigateToSignIn() {
        window.location.href = '/';
    }
}

export default ResetPasswordController;

